import { filterPlugin } from './filter_plugin'
export * from './types'

export default filterPlugin
